import { AvailableProducts } from 'routes/smart-quote/components/onboarding-list/available-product';
import { useHasActiveTabSmartQuotePrompts } from 'routes/smart-quote/hooks/use-sort-prompts';

import { QuickStart } from './quick-start';

export function OnboardingList() {
  const hasPrompts = useHasActiveTabSmartQuotePrompts();

  if (hasPrompts) {
    return null;
  }

  return (
    <ul className="list-group border-bottom border-opacity-40 mt-3">
      <li className="list-group-item list-group-item-secondary border-top border-opacity-40 d-grid p-0">
        <QuickStart />
      </li>
      <li
        className="list-group-item list-group-item-secondary border-top border-opacity-40 d-grid p-0"
        style={{ height: '48px' }}
      >
        <AvailableProducts />
      </li>
    </ul>
  );
}
